export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/check.048936ba.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};